import React from 'react';

export default class ComparisonDisplay extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="comparison-display">
        <div className="comparison-display__number">
          {this.props.leftNumber.toLocaleString()}
        </div>
        <div className="comparison-display__symbol">
          {this.props.equalitySymbol}
        </div>
        <div className="comparison-display__number">
          {this.props.rightNumber.toLocaleString()}
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/inequality/comparison_display.js
 **/